import React from 'react';
import { Button } from '@mantine/core';

interface MoreToursBtnProps {
    clickFunction: () => void;
    expanded?: boolean;
}

function MoreToursBtn({ clickFunction, expanded }: MoreToursBtnProps) {
    return (
        <div className="loadMoreToursBtnWrap">
            <Button
                className="loadMoreToursBtn"
                variant="light"
                color="brand"
                radius="xl"
                onClick={() => {
                    clickFunction();
                }}
            >
                {expanded ? "Show Less Tours" : "Load More Tours"}
            </Button>
        </div>
    );
}

export default MoreToursBtn;
